import { createFileRoute } from '@tanstack/react-router'

import { createEnumGuard } from '#/utils/typeGuards'
import { PERSONAL_CARD_STATUS_FILTERS, type TPersonalCardStatusFilter } from '#pages/PersonalCards/interfaces'

interface IPersonalCardsSearch {
  newCard?: boolean
  openEngravedId?: string
  search?: string
  sortBy?: string
  sortDir?: 'asc' | 'desc'
  cardStatus?: TPersonalCardStatusFilter
}

const isCardStatusSearch = createEnumGuard(PERSONAL_CARD_STATUS_FILTERS)

export const Route = createFileRoute('/_authenticated/companies_/$companyId/personal-cards')({
  validateSearch: (search: Record<string, unknown>): IPersonalCardsSearch => ({
    newCard: search.newCard === true || search.newCard === 'true' ? true : undefined,
    openEngravedId: typeof search.openEngravedId === 'string' ? search.openEngravedId : undefined,
    search: typeof search.search === 'string' ? search.search : undefined,
    sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
    sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
    cardStatus:
      typeof search.cardStatus === 'string' && isCardStatusSearch(search.cardStatus) ? search.cardStatus : undefined,
  }),
})
